export default __webpack_public_path__ + "static/media/img17.65301de0.png";